import { CompanyName } from '~/company/interface';

export const swiperProps = (company: CompanyName) =>
  company === CompanyName.CityDrinks ? {} : { isPagination: true };
